import { render, staticRenderFns } from "./BillingPackageNewPage.vue?vue&type=template&id=65622dca"
import script from "./BillingPackageNewPage.vue?vue&type=script&lang=ts"
export * from "./BillingPackageNewPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports